import { render, staticRenderFns } from "./StudentVisaDocuments.vue?vue&type=template&id=3f0f3aba&"
import script from "./StudentVisaDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentVisaDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StudentVisaDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports